var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-404"},[_c('div',{staticClass:"content-404-top"},[_vm._v(" 对不起您所访问的页面不存在或者已删除 ")]),_c('div',{staticClass:"content-404-bottom"},[_vm._v(" "+_vm._s(_vm.time)+"秒后 "),_c('span',{on:{"click":_vm.goto}},[_vm._v("返回")]),_vm._v(" 首页 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }